const DEFAULTS = {
  text: 'Embed saved successfully!',
  heading: 'Success',
  icon: 'success',
  hideAfter: 3000,
  position: 'top-right',
};

const TRANSITION_DURATION = 180; // Must match the toast exit transition timing in src/styles/tailwind.css

const toastWraps = new Map();

function getToastWrap(position) {
  if (!toastWraps.has(position)) {
    const wrap = document.createElement('div');
    wrap.style.position = 'fixed';
    wrap.style.pointerEvents = 'none';
    wrap.style.zIndex = '10000';
    wrap.style.width = '20rem';

    if (position === 'bottom-left') {
      wrap.style.top = 'auto';
      wrap.style.bottom = '1.25rem';
      wrap.style.left = '1.25rem';
      wrap.style.right = 'auto';
    } else if (position === 'bottom-right') {
      wrap.style.top = 'auto';
      wrap.style.bottom = '1.25rem';
      wrap.style.right = '2.5rem';
      wrap.style.left = 'auto';
    } else if (position === 'top-left') {
      wrap.style.top = '1.25rem';
      wrap.style.left = '1.25rem';
      wrap.style.right = 'auto';
    } else {
      wrap.style.top = '1.25rem';
      wrap.style.right = '2.5rem';
    }

    document.body.appendChild(wrap);
    toastWraps.set(position, wrap);
  }

  return toastWraps.get(position);
}

export default {
  makeToast(opts = {}) {
    const options = { ...DEFAULTS, ...opts };
    const wrap = getToastWrap(options.position);
    const toast = document.createElement('div');

    toast.style.pointerEvents = 'auto';
    toast.style.position = 'relative';
    toast.style.marginBottom = '0.3125rem';
    toast.style.overflow = 'hidden';
    toast.style.borderRadius = '0.25rem';
    toast.style.padding = '0.625rem';
    toast.style.fontSize = '0.75rem';
    toast.style.lineHeight = '1.0625rem';
    toast.style.color = '#fff';
    toast.style.borderLeft = `0.25rem solid ${({
      success: '#3c763d',
      error: '#a94442',
      info: '#31708f',
      warning: '#8a6d3b',
    }[options.icon] || '#444')}`;
    toast.style.boxShadow = '0 0.25rem 0.5rem rgba(0,0,0,0.25)';
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(-0.25rem)';
    toast.style.transition = 'opacity 180ms ease, transform 180ms ease';
    toast.style.backgroundColor = ({
      success: '#3c763d',
      error: '#a94442',
      info: '#31708f',
      warning: '#8a6d3b',
    }[options.icon] || '#444');

    const progress = document.createElement('div');
    progress.style.position = 'absolute';
    progress.style.top = '0';
    progress.style.left = '0';
    progress.style.height = '3px';
    progress.style.width = '100%';
    progress.style.transformOrigin = 'left center';
    progress.style.background = 'rgba(255, 255, 255, 0.45)';
    progress.style.animation = 'producer-toast-progress var(--toast-hide-after, 3000ms) linear forwards';

    const heading = document.createElement('div');
    heading.style.margin = '0 0 0.4375rem';
    heading.style.fontSize = '0.875rem';
    heading.style.fontWeight = '500';
    heading.style.lineHeight = 'inherit';
    heading.style.letterSpacing = 'normal';
    heading.textContent = options.heading;

    const text = document.createElement('div');
    text.style.margin = '0';
    text.textContent = options.text;

    toast.appendChild(progress);
    toast.appendChild(heading);
    toast.appendChild(text);

    toast.style.setProperty('--toast-hide-after', `${options.hideAfter}ms`);

    wrap.appendChild(toast);

    window.requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });

    window.setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-0.25rem)';
      window.setTimeout(() => {
        toast.remove();

        if (!wrap.children.length) {
          wrap.remove();
          toastWraps.delete(options.position);
        }
      }, TRANSITION_DURATION);
    }, options.hideAfter);
  },
};
